import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { adsContext } from '../UseContext/AdsContext';


const Parameters = () => {

  // ----- Radius Location -----

  const [radiusLocation, setRadiusLocation] = useState({
    includeExclude: 'include',
    location: '',
    radius: '10',
  });

  // handle add radius location
  const handleAddRadiusLocation = () => {
    // add to the list
    setAd({
      ...ad,
      radiusLocation: [...ad.radiusLocation, radiusLocation],
    });

    // clear form field after adding to the list
    setRadiusLocation({
      includeExclude: 'include',
      location: '',
      radius: '10',
    });
  };

  // handle change radius location
  const handleChangeRadiusLocation = (index, field, value) => {
    const updatedLocations = [...ad.radiusLocation];
    updatedLocations[index][field] = value;
    setAd((prev) => ({ ...prev, radiusLocation: updatedLocations }));
  };

  // handle remove radius location
  const handleRemoveRadiusLocation = (index) => {
    setAd((prev) => ({
      ...prev,
      radiusLocation: prev.radiusLocation.filter((_, i) => i !== index),
    }));
  };



  // ----- Custom Location -----

  // handle change custom location
  const handleChangeCustomLocation = (e) => {
    const { name, value } = e.target;

    setAd((prev) => ({
      ...prev,
      customLocation: {
        ...prev.customLocation,
        [name]: value,
      },
    }));
  };
  
  

  const navigate = useNavigate();

  const { ad, setAd } = useContext(adsContext);

  return (
    <>
      <section className='d-flex flex-column flex-xl-row gap-3 mb-3'>
        {/* Left Block */}
        <div className='create-campaign-left-block bg-light p-3 rounded-3 shadow-sm'>
          {/* Select Saved Audience */}
          <div className='bg-white p-3 rounded-3 mb-4'>
            <h5 className='mb-0'>Select Saved Audience</h5>

            <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

            <select className="form-select mt-1" value={ad.savedAudience} onChange={(e) => setAd({ ...ad, savedAudience: e.target.value })}>
              <option value='' disabled>Select saved audience</option>
              <option value="audience-1">Audience 1</option>
              <option value="audience-2">Audience 2</option>
              <option value="audience-3">Audience 3</option>
              <option value="audience-4">Audience 4</option>
              <option value="audience-5">Audience 5</option>
            </select>
          </div>

          {/* Location */}
          <div className='mb-5'>
            <h5 className='mb-0'>Location</h5>

            <small className='text-secondary'>Engaging Residents and Recent Visitors</small>

            {/* Radius Selection */}
            <div>
              <div className="form-check mt-4">
                <input type="radio" className="form-check-input mt-2" id="radius" name="locationSelection" value="radius" 
                  checked={ad.locationSelection === "radius"} onChange={(e) => setAd({ ...ad, locationSelection: e.target.value })} 
                />
                <label className="form-check-label fs-5 d-block fw-semibold" htmlFor="radius">Radius Selection</label>
                <small className='text-secondary'>Engaging Residents and Recent Visitors</small>
              </div>

              {/* Added Radius Location */}
              <>
                {
                  ad.radiusLocation.length > 0
                  &&
                  <div className='bg-secondary-subtle py-3 px-2 mt-3 rounded-4'>
                    {
                      ad.radiusLocation.map((value, index) => (
                        <div key={index}>
                          <div className={`d-flex flex-wrap flex-sm-nowrap align-items-center gap-3`}>
                            {/* Include/Exclude */}
                            <select className="form-select w-auto" name='includeExclude'
                              value={value.includeExclude} onChange={(e) => handleChangeRadiusLocation(index, e.target.name, e.target.value)}
                              >
                              <option value="include">Include</option>
                              <option value="exclude">Exclude</option>
                            </select>

                            <input type="search" className='form-control' name='location' placeholder='Search...'
                              value={value.location} onChange={(e) => handleChangeRadiusLocation(index, e.target.name, e.target.value)} 
                              />

                            {/* Radius */}
                            <select className="form-select w-auto" name='radius' value={value.radius} onChange={(e) => handleChangeRadiusLocation(index, e.target.name, e.target.value)}>
                              <option value="10">10mi</option>
                              <option value="20">20mi</option>
                              <option value="30">30mi</option>
                              <option value="40">40mi</option>
                              <option value="50">50mi</option>
                            </select>

                            <button type="button" className='btn btn-danger' onClick={() => handleRemoveRadiusLocation(index)}>Remove</button>
                          </div>

                          {
                            index !== ad.radiusLocation.length - 1
                            &&
                            <hr />
                          }
                        </div>
                      ))
                    }
                  </div>
                }
              </>

              {/* Add Radius Location */}
              <div className='d-flex flex-wrap flex-sm-nowrap align-items-center gap-3 mt-3'>
                {/* Include/Exclude */}
                <select className="form-select w-auto" 
                  value={radiusLocation.includeExclude} onChange={(e) => setRadiusLocation((prev) => ({ ...prev, includeExclude: e.target.value, }))}
                >
                  <option value="include">Include</option>
                  <option value="exclude">Exclude</option>
                </select>

                <input type="search" className='form-control' placeholder='Search...'
                  value={radiusLocation.location} onChange={(e) => setRadiusLocation(prev => ({ ...prev, location: e.target.value }))} 
                />

                {/* Radius */}
                <select className="form-select w-auto" value={radiusLocation.radius} onChange={(e) => setRadiusLocation(prev => ({ ...prev, radius: e.target.value }))}>
                  <option value="10">10mi</option>
                  <option value="20">20mi</option>
                  <option value="30">30mi</option>
                  <option value="40">40mi</option>
                  <option value="50">50mi</option>
                </select>

                <button type="button" className='btn btn-primary' onClick={handleAddRadiusLocation} disabled={radiusLocation.location === ''}>Add</button>
              </div>

              <img src="/images/radius-selection-map.png" className='mt-3 w-100' alt="radius-selection-map" />
            </div>

            {/* Custom Selection */}
            <div>
              <div className="form-check my-4">
                <input type="radio" className="form-check-input mt-2" name="locationSelection" value="custom" id="custom"
                  checked={ad.locationSelection === "custom"} onChange={(e) => setAd({ ...ad, locationSelection: e.target.value })}  
                />
                <label className="form-check-label fs-5 d-block fw-semibold" htmlFor="custom">Custom Selection</label>
                <small className='text-secondary'>Engaging Residents and Recent Visitors</small>
              </div>

              {/* Country */}
              <div className='mb-4'>
                <h5 className='mb-2'>Country</h5>
                <select className="form-select" name="country" value={ad.customLocation.country} onChange={handleChangeCustomLocation} >
                  <option value="India">India</option>
                  <option value="USA">USA</option>
                  <option value="UK">UK</option>
                  <option value="Australia">Australia</option>
                </select>
              </div>

              {/* State */}
              <div className='mb-4'>
                <h5 className='mb-2'>State</h5>
                <select className="form-select" name="state" value={ad.customLocation.state} onChange={handleChangeCustomLocation} >
                  <option value="Chhattisgarh">Chhattisgarh</option>
                  <option value="Maharashtra">Maharashtra</option>
                  <option value="Karnataka">Karnataka</option>
                  <option value="Gujarat">Gujarat</option>
                </select>
              </div>

              {/* City */}
              <div className='mb-4'>
                <h5 className='mb-2'>City</h5>
                <select className="form-select" name="cityInclude" value={ad.customLocation.cityInclude} onChange={handleChangeCustomLocation} >
                  <option value="Raipur">Raipur</option>
                  <option value="Mumbai">Mumbai</option>
                  <option value="Bengaluru">Bengaluru</option>
                  <option value="Ahmedabad">Ahmedabad</option>
                </select>
              </div>

              {/* City (Exclude) */}
              <div className='mb-4'>
                <h5 className='mb-2'>City (Exclude)</h5>
                <select className="form-select" name="cityExclude" value={ad.customLocation.cityExclude} onChange={handleChangeCustomLocation} >
                  <option value="Durg">Durg</option>
                  <option value="Delhi">Delhi</option>
                  <option value="Pune">Pune</option>
                  <option value="Surat">Surat</option>
                </select>
              </div>

              {/* Age */}
              <div className='mb-4'>
                <h5 className='mb-2'>Age</h5>
                <div className='mb-3'>
                  <label htmlFor="minAge">Min Age: </label>
                  <input type="number" id="minAge" className='mx-3' name="minAge" min="1" max="100" value={ad.customLocation.minAge} onChange={handleChangeCustomLocation}/>
                </div>

                <div>
                  <label htmlFor="maxAge">Max Age: </label>
                  <input type="number" id="maxAge" className='mx-3' name="maxAge" min="1" max="100" value={ad.customLocation.maxAge} onChange={handleChangeCustomLocation} />
                </div>
              </div>

              {/* Gender */}
              <div>
                <h5 className='mb-2'>Gender</h5>
                <div className='d-flex align-items-center gap-3 flex-wrap'>
                  <div className="bg-white border rounded-3 p-2 d-flex align-items-center gap-2">
                    <input className="form-check-input mt-0" type="radio" name="gender" id="all" value="all" checked={ad.customLocation.gender === 'all'} onChange={handleChangeCustomLocation} />
                    <label className="form-check-label" htmlFor="all">All</label>
                  </div>

                  <div className="bg-white border rounded-3 p-2 d-flex align-items-center gap-2">
                    <input className="form-check-input mt-0" type="radio" name="gender" id="male" value="male" checked={ad.customLocation.gender === 'male'} onChange={handleChangeCustomLocation} />
                    <label className="form-check-label" htmlFor="male">Male</label>
                  </div>

                  <div className="bg-white border rounded-3 p-2 d-flex align-items-center gap-2">
                    <input className="form-check-input mt-0" type="radio" name="gender" id="female" value="female" checked={ad.customLocation.gender === 'female'} onChange={handleChangeCustomLocation} />
                    <label className="form-check-label" htmlFor="female">Female</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Hobbies, Occupation & Places Visited */}
          <div className='bg-white p-3 rounded-3 mb-3'>
            {/* Hobbies */}
            <div className='mb-4'>
              <h5 className='mb-0'>Hobbies</h5>

              <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

              <select className="form-select mt-1" value={ad.hobbies} onChange={(e) => setAd((prevAd) => ({ ...prevAd, hobbies: e.target.value }))}>
                <option value='' disabled>Select from hobbies the list</option>
                <option value="one">One</option>
                <option value="two">Two</option>
                <option value="three">Three</option>
              </select>
            </div>

            {/* Occupation */}
            <div className='mb-4'>
              <h5 className='mb-0'>Occupation</h5>

              <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

              <select className="form-select mt-1" value={ad.occupation} onChange={(e) => setAd((prevAd) => ({ ...prevAd, occupation: e.target.value }))}>
                <option value='' disabled>Select from occupation the list</option>
                <option value="one">One</option>
                <option value="two">Two</option>
                <option value="three">Three</option>
              </select>
            </div>

            {/* Places Visited */}
            <div className='mb-4'>
              <h5 className='mb-0'>Places Visited</h5>

              <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

              <select className="form-select mt-1" value={ad.placesVisited} onChange={(e) => setAd((prevAd) => ({ ...prevAd, placesVisited: e.target.value }))}>
                <option value='' disabled>Select from visited places the list</option>
                <option value="one">One</option>
                <option value="two">Two</option>
                <option value="three">Three</option>
              </select>
            </div>
          </div>

          {/* Schedule */}
          <div className='bg-white p-3 rounded-3 mb-3'>
            <h5 className='mb-0'>Schedule</h5>

            <small>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia exercitationem culpa, modi dicta labore nulla laudantium ipsa quos blanditiis ipsam!</small>

            {/* Start Date */}
            <div className='mt-3'>
              <h5 className='mb-2'>Start Date</h5>

              <div className='d-flex gap-3 flex-wrap'>
                <input type="date" className='form-control w-auto' value={ad.startDate} onChange={(e) => setAd((prevAd) => ({ ...prevAd, startDate: e.target.value }))} />
                <input type="time" className='form-control w-auto' value={ad.startTime} onChange={(e) => setAd((prevAd) => ({ ...prevAd, startTime: e.target.value }))} />
              </div>
            </div>

            {/* End Date */}
            <div className='mt-3'>
              <h5 className='mb-2'>End Date</h5>

              <div className='d-flex gap-3 flex-wrap'>
                <input type="date" className='form-control w-auto' value={ad.endDate} onChange={(e) => setAd((prevAd) => ({ ...prevAd, endDate: e.target.value }))} />
                <input type="time" className='form-control w-auto' value={ad.endTime} onChange={(e) => setAd((prevAd) => ({ ...prevAd, endTime: e.target.value }))} />
              </div>
            </div>

            {/* Frequency */}
            <div className='mt-3'>
              <h5 className='mb-2'>Frequency</h5>

              <select className="form-select" value={ad.frequency} onChange={(e) => setAd((prevAd) => ({ ...prevAd, frequency: e.target.value }))}>
                <option value='' disabled>Select frequency of the ad</option>
                <option value="one">One</option>
                <option value="two">Two</option>
                <option value="three">Three</option>
              </select>
            </div>
          </div>

          {/* Buttons */}
          <div className='d-flex align-items-center justify-content-between gap-3 flex-wrap'>
            <button type="button" className='btn btn-success flex-grow-1'>Save Draft</button>
            <button type="button" className='btn bg-secondary-subtle text-primary flex-grow-1' onClick={() => navigate(`/campaigns/media`)}>Show Preview</button>
            <button type="button" className='btn bg-secondary-subtle flex-grow-1'>Cancel</button>
            <button type="button" className='btn btn-primary flex-grow-1' onClick={() => navigate(`/campaigns/lead-generation`)}>Next</button>
          </div>
        </div>

        {/* Right Block */}
        <div className='create-campaign-right-block bg-light p-3 rounded-3 shadow-sm'>Right Block</div>
      </section> 
    </>
  );
};

export default Parameters;